module.exports = __webpack_public_path__ + "static/media/icon_equipments.f6bbbeb1.svg";